/* SANA size guide page (22 Oct 2026). Loaded by sections/sana-size-guide.liquid. */
(function () {
  'use strict';
  var root = document.getElementById('sana-sg');
  var dataEl = document.getElementById('sana-sg-data');
  if (!root || !dataEl) return;

  var RAW = [];
  try { RAW = JSON.parse(dataEl.textContent); } catch (e) { RAW = []; }

  var STORE_KEY = 'sana-size-finder-v1';
  var IN = 2.54;
  var MEASURES = ['bust', 'waist', 'hips'];
  var LIMITS = { bust: [50, 200], waist: [40, 200], hips: [50, 220], height: [100, 230] };
  var SCALE = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  var SYS_LABEL = { au: 'AU', uk: 'UK', us: 'US', eu: 'EU' };
  var M_LABEL = { bust: 'Bust', waist: 'Waist', hips: 'Hips' };
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function q(s, c) { return (c || root).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fold(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s;
  }
  function styleName(title) { return String(title || '').split(/\s+[—–-]\s+/)[0].trim(); }
  function joinWords(w) {
    if (w.length <= 1) return w.join('');
    return w.slice(0, -1).join(', ') + ' and ' + w[w.length - 1];
  }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function nice(s) {
    // "MARIA — COFFEE" -> "Maria — Coffee"; keeps accents (ESMÉ -> Esmé).
    return String(s || '').toLowerCase().replace(/(^|[\s\-—(])([a-zà-ÿ])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }

  // ── size_and_fit metafield → model line, table, notes ─────────────────────
  function textOf(html) {
    var d = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    return (d.body.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function parseSF(raw) {
    raw = String(raw || '');
    var out = { model: '', notes: [], headers: [], rows: [], sig: '' };
    var i = raw.indexOf('<table');
    var j = raw.indexOf('</table>');
    var before = raw;
    var after = '';
    if (i >= 0 && j > i) {
      before = raw.slice(0, i);
      after = raw.slice(j + 8);
      var doc = new DOMParser().parseFromString(raw.slice(i, j + 8), 'text/html');
      var trs = doc.querySelectorAll('tr');
      for (var k = 0; k < trs.length; k++) {
        var cells = Array.prototype.map.call(trs[k].children, function (c) {
          return (c.textContent || '').replace(/\s+/g, ' ').trim();
        });
        if (k === 0 && trs[k].querySelector('th')) out.headers = cells;
        else out.rows.push(cells);
      }
      out.sig = (out.headers.join('|') + '#' + out.rows.map(function (r) { return r.join('|'); }).join('#')).toLowerCase().replace(/\s+/g, '');
    }
    before.split(/\r?\n/).concat(after.split(/\r?\n/)).forEach(function (line) {
      var t = textOf(line);
      if (!t) return;
      if (!out.model && /\bmodel\b/i.test(t)) out.model = t;
      else out.notes.push(t);
    });
    return out;
  }

  // "Model is 173cm and wearing size XS ( Usually wears size S )"
  //   -> { heightCm: 173, text: 'Model is 173cm and wears XS (usually S)' }
  function parseModel(line) {
    if (!line) return null;
    var main = line.split('(')[0];
    var cm = main.match(/(\d{3}(?:\.\d)?)\s*cm/i);
    var wears = main.match(/wear(?:s|ing)\s+(?:a\s+)?(?:size\s+)?([A-Za-z0-9\/]+)/i);
    var usually = line.match(/usually\s+wear(?:s|ing)?\s+(?:a\s+)?(?:size\s+)?([A-Za-z0-9\/]+)/i);
    var h = cm ? Math.round(Number(cm[1])) : null;
    var w = wears ? wears[1].toUpperCase() : null;
    var u = usually ? usually[1].toUpperCase() : null;
    if (!h && !w) return { heightCm: null, text: line };
    var text = h && w ? 'Model is ' + h + 'cm and wears ' + w : w ? 'Model wears ' + w : 'Model is ' + h + 'cm';
    if (u && w && u !== w) text += ' (usually ' + u + ')';
    return { heightCm: h, text: text };
  }

  // ── Chart ─────────────────────────────────────────────────────────────────
  function classify(n) {
    n = String(n || '').toLowerCase();
    if (/bust|chest/.test(n)) return 'bust';
    if (/waist/.test(n)) return 'waist';
    if (/hip/.test(n)) return 'hips';
    if (/\baus?\b|australia/.test(n)) return 'au';
    if (/\buk\b/.test(n)) return 'uk';
    if (/\bus\b|\busa\b/.test(n)) return 'us';
    if (/\beu\b|\beur\b/.test(n)) return 'eu';
    if (/size/.test(n)) return 'size';
    return null;
  }
  function sizeKey(label) {
    var s = String(label || '').trim().toUpperCase().replace(/\s+/g, '');
    if (s === '2XS') s = 'XXS';
    if (s === '2XL') s = 'XXL';
    return SCALE.indexOf(s) >= 0 ? s : null;
  }
  function range(cell) {
    var t = String(cell || '').replace(/(\d),(\d)/g, '$1.$2');
    var n = (t.match(/\d+(?:\.\d+)?/g) || []).map(Number);
    if (!n.length) return null;
    if (n.length === 1) return { min: n[0], max: n[0] };
    return { min: Math.min(n[0], n[1]), max: Math.max(n[0], n[1]) };
  }
  function buildChart(headers, rows) {
    var h = headers.slice();
    var r = rows.slice();
    if (!h.length && r.length > 1) { h = r[0]; r = r.slice(1); }
    if (!r.length) return null;
    var map = {};
    var order = [];
    function entry(label) {
      var k = sizeKey(label);
      if (!k) return null;
      if (!map[k]) { map[k] = { size: k, sys: {}, m: {} }; order.push(k); }
      return map[k];
    }
    function put(e, kind, cell) {
      if (!e || !kind || kind === 'size') return;
      var c = String(cell || '').trim();
      if (!c) return;
      if (MEASURES.indexOf(kind) >= 0) { var rg = range(c); if (rg) e.m[kind] = rg; }
      else e.sys[kind] = c;
    }
    var sizeCols = h.slice(1).filter(sizeKey).length;
    if (sizeCols >= 2) {
      for (var j = 1; j < h.length; j++) {
        var e = entry(h[j]);
        r.forEach(function (row) { put(e, classify(row[0]), row[j]); });
      }
    } else {
      var kinds = h.map(classify);
      r.forEach(function (row) {
        var e2 = entry(row[0]);
        for (var c = 1; c < row.length; c++) put(e2, kinds[c], row[c]);
      });
    }
    var list = order.map(function (k) { return map[k]; }).sort(function (a, b) {
      return SCALE.indexOf(a.size) - SCALE.indexOf(b.size);
    });
    if (!list.length) return null;
    // A chart written in inches (bust or hips under 60, waist under 50) is converted to cm.
    MEASURES.forEach(function (m) {
      var vals = list.filter(function (e) { return e.m[m]; }).map(function (e) { return e.m[m].max; }).sort(function (a, b) { return a - b; });
      if (!vals.length) return;
      if (vals[Math.floor(vals.length / 2)] < (m === 'waist' ? 50 : 60)) {
        list.forEach(function (e) {
          if (e.m[m]) e.m[m] = { min: Math.round(e.m[m].min * IN * 10) / 10, max: Math.round(e.m[m].max * IN * 10) / 10 };
        });
      }
    });
    return {
      entries: list,
      measures: MEASURES.filter(function (m) { return list.filter(function (e) { return e.m[m]; }).length >= 2; }),
      systems: ['au', 'uk', 'us', 'eu'].filter(function (s) { return list.some(function (e) { return e.sys[s]; }); })
    };
  }

  // ── Placement (port of the app's Fit Confidence placeMeasurement) ─────────
  function place(value, ranges) {
    var n = ranges.length;
    var inside = [];
    for (var k = 0; k < n; k++) if (value >= ranges[k].min && value <= ranges[k].max) inside.push(k);
    if (inside.length === 1) return { kind: 'in', k: inside[0] };
    if (inside.length >= 2) return { kind: 'between', k: inside[0] };
    var firstGap = n > 1 ? Math.max(ranges[1].min - ranges[0].max, 1) : 2;
    if (value < ranges[0].min) return ranges[0].min - value <= 0.25 * firstGap ? { kind: 'in', k: 0 } : { kind: 'below' };
    var lastGap = n > 1 ? Math.max(ranges[n - 1].min - ranges[n - 2].max, 1) : 2;
    if (value > ranges[n - 1].max) return value - ranges[n - 1].max <= 0.25 * lastGap ? { kind: 'in', k: n - 1 } : { kind: 'above' };
    for (var i = 0; i < n - 1; i++) {
      var lo = ranges[i].max;
      var hi = ranges[i + 1].min;
      if (value > lo && value < hi) {
        var gap = hi - lo;
        var d = value - lo;
        if (d <= 0.25 * gap) return { kind: 'in', k: i };
        if (gap - d <= 0.25 * gap) return { kind: 'in', k: i + 1 };
        return { kind: 'between', k: i };
      }
    }
    return { kind: 'in', k: n - 1 };
  }

  function recommend(chart, vals) {
    var used = [];
    chart.measures.forEach(function (m) {
      var v = vals[m];
      if (!(v > 0)) return;
      var withM = chart.entries.filter(function (e) { return e.m[m]; });
      var p = place(v, withM.map(function (e) { return e.m[m]; }));
      var idx = function (k) { return chart.entries.indexOf(withM[k]); };
      var u = { m: m, v: v, kind: p.kind };
      if (p.kind === 'in') { u.lo = u.hi = idx(p.k); u.pos = u.lo; }
      else if (p.kind === 'between') { u.lo = idx(p.k); u.hi = idx(p.k + 1); u.pos = u.lo + 0.5; }
      else if (p.kind === 'below') { u.lo = u.hi = idx(0); u.pos = u.lo; u.first = withM[0]; }
      else { u.lo = u.hi = idx(withM.length - 1); u.pos = u.lo; u.last = withM[withM.length - 1]; }
      used.push(u);
    });
    var ignored = MEASURES.filter(function (m) { return vals[m] > 0 && chart.measures.indexOf(m) < 0; });
    var missing = chart.measures.filter(function (m) { return !(vals[m] > 0); });
    if (!used.length) return { none: true, ignored: ignored, missing: missing };
    var pos = used.map(function (u) { return u.pos; });
    var maxPos = Math.max.apply(null, pos);
    var minPos = Math.min.apply(null, pos);
    var between = maxPos % 1 !== 0;
    var pick = between ? Math.ceil(maxPos) : maxPos;
    return {
      size: chart.entries[pick].size,
      entry: chart.entries[pick],
      pick: pick,
      between: between,
      lower: between ? chart.entries[Math.floor(maxPos)].size : null,
      used: used,
      above: used.filter(function (u) { return u.kind === 'above'; }),
      allBelow: used.every(function (u) { return u.kind === 'below'; }),
      spread: maxPos !== minPos,
      ignored: ignored,
      missing: missing
    };
  }

  function placeWord(u, chart) {
    var e = chart.entries;
    if (u.kind === 'in') return e[u.lo].size;
    if (u.kind === 'between') return e[u.lo].size + '–' + e[u.hi].size;
    if (u.kind === 'below') return 'Below ' + e[u.lo].size;
    return 'Above ' + e[u.lo].size;
  }

  // "hips" takes a plural verb on its own: "your hips fit M", "your bust fits M".
  function plural(ms) { return ms.length > 1 || ms[0] === 'hips'; }

  // The "why" sentence. Talks about sizes and charts, never about the shopper's body.
  function explain(rec, chart) {
    var e = chart.entries;
    var top = e[rec.pick].size;
    if (rec.above.length) {
      var a = rec.above[0];
      return {
        warn: true,
        html: 'Your ' + joinWords(rec.above.map(function (u) { return u.m; })) + ' ' + (plural(rec.above.map(function (u) { return u.m; })) ? 'measure' : 'measures') +
          ' above our largest size in this chart (<strong>' + esc(top) + '</strong>, up to ' + fmtVal(a.last.m[a.m].max) + '). ' +
          esc(top) + ' is the closest size we make and may feel snug, so we\'d love to help before you order.'
      };
    }
    if (rec.allBelow) {
      return {
        warn: true,
        html: 'Your measurements sit below our smallest size in this chart (<strong>' + esc(top) + '</strong>). ' +
          esc(top) + ' is the closest size we make and may feel a little roomy, so we\'d love to help before you order.'
      };
    }
    // Group measurements by where they sit: "your bust and hips fit M", "your waist sits between S and M".
    var buckets = [];
    rec.used.forEach(function (u) {
      var key = u.kind + ':' + u.lo + ':' + u.hi;
      var b = null;
      for (var i = 0; i < buckets.length; i++) if (buckets[i].key === key) b = buckets[i];
      if (!b) { b = { key: key, u: u, ms: [] }; buckets.push(b); }
      b.ms.push(u.m);
    });
    buckets.sort(function (x, y) { return x.u.pos - y.u.pos; });
    var parts = buckets.map(function (b) {
      var many = plural(b.ms);
      var who = 'your ' + joinWords(b.ms) + ' ';
      if (b.u.kind === 'between') return who + (many ? 'sit' : 'sits') + ' between ' + esc(e[b.u.lo].size) + ' and ' + esc(e[b.u.hi].size);
      if (b.u.kind === 'below') return who + (many ? 'sit' : 'sits') + ' below our ' + esc(e[b.u.lo].size);
      return who + (many ? 'fit' : 'fits') + ' ' + esc(e[b.u.lo].size);
    });
    var said = cap(joinWords(parts));
    if (rec.between) {
      return { html: said + '. Between sizes, we always size up, so <strong>we recommend ' + esc(top) + '</strong>.' };
    }
    if (!rec.spread) {
      return { html: said + '; <strong>we recommend ' + esc(top) + '</strong>.' };
    }
    return { html: said + '. <strong>We recommend ' + esc(top) + '</strong>, so it\'s comfortable throughout.' };
  }

  // ── Units ─────────────────────────────────────────────────────────────────
  var state = { unit: 'cm', piece: null, vals: {}, rec: null };
  function num(n) { return String(Math.round(n * 10) / 10).replace(/\.0$/, ''); }
  function fmtVal(cm) { return state.unit === 'in' ? num(cm / IN) + ' in' : num(cm) + ' cm'; }
  function fmtRange(r, unitless) {
    var f = function (v) { return state.unit === 'in' ? num(v / IN) : num(v); };
    var s = r.min === r.max ? f(r.min) : f(r.min) + '–' + f(r.max);
    return unitless ? s : s + (state.unit === 'in' ? ' in' : ' cm');
  }

  // ── Data model ────────────────────────────────────────────────────────────
  var pieces = [];
  var byHandle = {};
  var groups = [];
  RAW.forEach(function (p) {
    var sf = parseSF(p.sf);
    var piece = {
      h: p.h, t: p.t, ty: p.ty, u: p.u, img: p.img, big: p.big, alt: p.alt, v: p.v || {},
      sf: sf, model: parseModel(sf.model), chart: buildChart(sf.headers, sf.rows), group: null,
      key: fold(p.t + ' ' + p.ty + ' ' + styleName(p.t))
    };
    pieces.push(piece);
    byHandle[p.h] = piece;
    if (!piece.chart) return;
    var g = null;
    for (var i = 0; i < groups.length; i++) if (groups[i].sig === sf.sig) g = groups[i];
    if (!g) { g = { id: 'sg-chart-' + (groups.length + 1), sig: sf.sig, chart: piece.chart, pieces: [] }; groups.push(g); }
    g.pieces.push(piece);
    piece.group = g;
  });
  groups.forEach(function (g) {
    var names = [];
    g.pieces.forEach(function (p) { var n = nice(styleName(p.t)); if (names.indexOf(n) < 0) names.push(n); });
    g.names = names;
    g.title = names.join(' · ');
  });
  groups.sort(function (a, b) { return b.names.length - a.names.length; });

  // ── Chart rendering: table on desktop, swipeable size cards on phones ─────
  var chartSeq = 0;
  function span(n) { return [12, 12, 6, 4, 3][n] || 6; }
  function renderChart(g, opts) {
    opts = opts || {};
    var c = g.chart;
    var uid = 'sgc' + (++chartSeq);
    var recSize = state.rec && state.rec.group === g && !state.rec.res.none ? state.rec.res.size : null;
    var html = '';
    if (opts.head !== false) {
      html += '<div class="sg-chart-head"><h3>' + esc(g.title) + '</h3><p>' +
        g.pieces.map(function (p) { return '<a href="' + esc(p.u) + '">' + esc(nice(p.t)) + '</a>'; }).join(', ') + '</p></div>';
    }
    // Phone: tabs + swipe track.
    var startIdx = 0;
    c.entries.forEach(function (e, i) { if (e.size === recSize) startIdx = i; });
    html += '<div class="sg-tabs" role="tablist" aria-label="Sizes">';
    c.entries.forEach(function (e, i) {
      html += '<button type="button" role="tab" class="sg-tab' + (e.size === recSize ? ' is-rec' : '') + '" id="' + uid + '-t' + i +
        '" aria-controls="' + uid + '-p' + i + '" aria-selected="' + (i === startIdx) + '" tabindex="' + (i === startIdx ? 0 : -1) +
        '" data-sg-tab="' + i + '">' + esc(e.size) + (e.size === recSize ? '<span class="sg-vh"> (recommended)</span>' : '') + '</button>';
    });
    html += '</div><div class="sg-track" data-sg-track data-start="' + startIdx + '">';
    c.entries.forEach(function (e, i) {
      html += '<div class="sg-panel' + (e.size === recSize ? ' is-rec' : '') + '" role="tabpanel" id="' + uid + '-p' + i + '" aria-labelledby="' + uid + '-t' + i + '">' +
        '<p class="sg-panel-flag">Your recommended size</p><dl>';
      // One row of size systems, then one row of measurements, on a 12-column grid.
      c.systems.forEach(function (s) { html += '<div style="grid-column:span ' + span(c.systems.length) + '"><dt>' + SYS_LABEL[s] + '</dt><dd>' + esc(e.sys[s] || '–') + '</dd></div>'; });
      c.measures.forEach(function (m) {
        html += '<div class="is-m" style="grid-column:span ' + span(c.measures.length) + '"><dt>' + M_LABEL[m] + '</dt><dd>' + (e.m[m] ? esc(fmtRange(e.m[m], true)) + '<small>' + state.unit + '</small>' : '–') + '</dd></div>';
      });
      html += '</dl></div>';
    });
    html += '</div><div class="sg-swipe" aria-hidden="true">';
    c.entries.forEach(function (e, i) { html += '<i' + (i === startIdx ? ' class="is-on"' : '') + '></i>'; });
    html += '</div>';
    // Desktop: horizontal table.
    html += '<div class="sg-table-wrap"><table class="sg-table"><caption class="sg-vh">Size chart: ' + esc(g.title) + ', measurements in ' +
      (state.unit === 'in' ? 'inches' : 'centimetres') + '</caption><thead><tr><th scope="col"><span class="sg-vh">Size</span></th>';
    c.entries.forEach(function (e) {
      html += '<th scope="col"' + (e.size === recSize ? ' class="is-rec"' : '') + '>' + esc(e.size) + (e.size === recSize ? '<span class="sg-vh"> (recommended)</span>' : '') + '</th>';
    });
    html += '</tr></thead><tbody>';
    c.systems.forEach(function (s) {
      html += '<tr><th scope="row">' + SYS_LABEL[s] + '</th>';
      c.entries.forEach(function (e) { html += '<td' + (e.size === recSize ? ' class="is-rec"' : '') + '>' + esc(e.sys[s] || '–') + '</td>'; });
      html += '</tr>';
    });
    c.measures.forEach(function (m) {
      html += '<tr class="is-m"><th scope="row">' + M_LABEL[m] + ' (' + state.unit + ')</th>';
      c.entries.forEach(function (e) { html += '<td' + (e.size === recSize ? ' class="is-rec"' : '') + '>' + (e.m[m] ? esc(fmtRange(e.m[m], true)) : '–') + '</td>'; });
      html += '</tr>';
    });
    html += '</tbody></table></div>';
    if (c.measures.length && c.measures.length < 3) {
      html += '<p class="sg-chart-note">This chart lists ' + joinWords(c.measures) + ' only.</p>';
    }
    return '<div class="sg-chart"' + (opts.id ? ' id="' + opts.id + '"' : '') + '>' + html + '</div>';
  }

  function initTracks(scope) {
    qa('[data-sg-track]', scope).forEach(function (track) {
      var start = Number(track.getAttribute('data-start')) || 0;
      if (start) track.scrollLeft = start * track.clientWidth;
    });
  }

  function selectTab(chartEl, i, scroll) {
    var tabs = qa('[data-sg-tab]', chartEl);
    var dots = qa('.sg-swipe i', chartEl);
    tabs.forEach(function (t, k) {
      t.setAttribute('aria-selected', k === i ? 'true' : 'false');
      t.tabIndex = k === i ? 0 : -1;
    });
    dots.forEach(function (d, k) { d.className = k === i ? 'is-on' : ''; });
    if (scroll) {
      var track = q('[data-sg-track]', chartEl);
      if (track) {
        var left = i * track.clientWidth;
        try { track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = left; }
      }
    }
  }

  root.addEventListener('click', function (ev) {
    var tab = ev.target.closest && ev.target.closest('[data-sg-tab]');
    if (tab) selectTab(tab.closest('.sg-chart'), Number(tab.getAttribute('data-sg-tab')), true);
  });
  root.addEventListener('keydown', function (ev) {
    var tab = ev.target.closest && ev.target.closest('[data-sg-tab]');
    if (!tab) return;
    var chartEl = tab.closest('.sg-chart');
    var n = qa('[data-sg-tab]', chartEl).length;
    var i = Number(tab.getAttribute('data-sg-tab'));
    var next = null;
    if (ev.key === 'ArrowRight') next = (i + 1) % n;
    else if (ev.key === 'ArrowLeft') next = (i - 1 + n) % n;
    else if (ev.key === 'Home') next = 0;
    else if (ev.key === 'End') next = n - 1;
    if (next == null) return;
    ev.preventDefault();
    selectTab(chartEl, next, true);
    qa('[data-sg-tab]', chartEl)[next].focus();
  });
  var scrollTimer = null;
  root.addEventListener('scroll', function (ev) {
    var track = ev.target;
    if (!track || !track.hasAttribute || !track.hasAttribute('data-sg-track')) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      selectTab(track.closest('.sg-chart'), i, false);
    }, 60);
  }, true);

  // ── Size charts section ───────────────────────────────────────────────────
  var chartsEl = q('[data-sg-charts]');
  function renderAllCharts() {
    if (!chartsEl) return;
    if (!groups.length) {
      chartsEl.innerHTML = '<div class="sg-noscript">' + '<p>Our size charts are being updated. Please chat with us and we\'ll help with sizing.</p></div>';
      return;
    }
    chartsEl.innerHTML = groups.map(function (g) { return renderChart(g, { id: g.id }); }).join('');
    initTracks(chartsEl);
  }

  // ── Search (type-ahead over the pieces on this page) ──────────────────────
  var input = q('#sg-q');
  var list = q('#sg-q-list');
  var clearBtn = q('[data-sg-clear]');
  var active = -1;
  var results = [];

  function hilite(title, terms) {
    var t = esc(nice(title));
    if (!terms.length) return t;
    var f = fold(nice(title));
    var hit = terms[0];
    var at = f.indexOf(hit);
    if (at < 0) return t;
    var raw = nice(title);
    return esc(raw.slice(0, at)) + '<mark>' + esc(raw.slice(at, at + hit.length)) + '</mark>' + esc(raw.slice(at + hit.length));
  }
  function renderList() {
    var terms = fold(input.value).split(/\s+/).filter(Boolean);
    results = pieces.filter(function (p) {
      return terms.every(function (t) { return p.key.indexOf(t) >= 0; });
    }).slice(0, 8);
    active = -1;
    if (!results.length) {
      list.innerHTML = '<li class="sg-empty" role="option" aria-disabled="true">No pieces match “' + esc(input.value) + '”. Try another name, or choose from the pieces below.</li>';
    } else {
      list.innerHTML = results.map(function (p, i) {
        var sizes = Object.keys(p.v).join(' · ');
        return '<li class="sg-opt" role="option" id="sg-opt-' + i + '" aria-selected="false" data-i="' + i + '">' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="" width="40" height="50" loading="lazy">' : '') +
          '<span><b>' + hilite(p.t, terms) + '</b><small>' + esc(p.ty) + (sizes ? ' · ' + esc(sizes) : '') + '</small></span></li>';
      }).join('');
    }
    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    input.removeAttribute('aria-activedescendant');
  }
  function closeList() {
    list.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    active = -1;
  }
  function setActive(i) {
    var opts = qa('.sg-opt', list);
    if (!opts.length) return;
    active = (i + opts.length) % opts.length;
    opts.forEach(function (o, k) { o.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
    input.setAttribute('aria-activedescendant', 'sg-opt-' + active);
    opts[active].scrollIntoView({ block: 'nearest' });
  }
  if (input && list) {
    input.addEventListener('input', function () { clearBtn.hidden = !input.value; renderList(); });
    input.addEventListener('focus', function () { renderList(); });
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown') { ev.preventDefault(); if (list.hidden) renderList(); setActive(active + 1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); setActive(active - 1); }
      else if (ev.key === 'Enter') {
        ev.preventDefault();
        var p = results[active >= 0 ? active : 0];
        if (p) { selectPiece(p.h, { scroll: true }); closeList(); input.blur(); }
      } else if (ev.key === 'Escape') { closeList(); }
    });
    input.addEventListener('blur', function () { setTimeout(closeList, 150); });
    list.addEventListener('mousedown', function (ev) { ev.preventDefault(); });
    list.addEventListener('click', function (ev) {
      var li = ev.target.closest('.sg-opt');
      if (!li) return;
      var p = results[Number(li.getAttribute('data-i'))];
      if (p) { selectPiece(p.h, { scroll: true }); closeList(); input.blur(); }
    });
    clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; input.focus(); });
  }

  // ── Picked piece ──────────────────────────────────────────────────────────
  var pickedEl = q('#sg-picked');
  var forEl = q('[data-sg-for]');
  function renderPicked() {
    var p = state.piece;
    qa('[data-sg-pick]').forEach(function (b) { b.setAttribute('aria-pressed', p && b.getAttribute('data-sg-pick') === p.h ? 'true' : 'false'); });
    if (forEl) forEl.textContent = p ? nice(p.t) : 'All our pieces';
    if (!p) { pickedEl.hidden = true; pickedEl.innerHTML = ''; return; }
    var g = p.group;
    var html = '<div class="sg-picked-grid">';
    html += '<div class="sg-picked-img">' + (p.big ? '<img src="' + esc(p.big) + '" alt="' + esc(p.alt) + '" loading="lazy" width="800" height="1000">' : '') + '</div>';
    html += '<div class="sg-picked-body"><p class="sg-eyebrow">' + esc(p.ty) + '</p><h3>' + esc(nice(p.t)) + '</h3>';
    if (p.model) {
      html += '<p class="sg-model"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M7 3v18M7 7h3M7 11h4M7 15h3M7 19h4"/></svg><span>' + esc(p.model.text) + '</span></p>';
    }
    if (g) {
      var others = g.names.filter(function (n) { return n !== nice(styleName(p.t)); });
      html += '<p class="sg-share">' + (others.length ? 'Shares its size chart with ' + esc(joinWords(others)) + '.' : 'This style has its own size chart.') + '</p>';
      html += renderChart(g, { head: false });
    } else {
      html += '<p class="sg-nochart">We don\'t have a size chart for this piece on our website yet. Chat with us or email ' + esc(root.getAttribute('data-email')) + ' and we\'ll help you choose your size.</p>';
    }
    if (p.sf.notes.length) {
      html += '<div class="sg-notes">' + p.sf.notes.map(function (n) { return '<p>' + esc(n) + '</p>'; }).join('') + '</div>';
    }
    html += '<div class="sg-picked-actions">' +
      (g ? '<a class="sg-btn sg-btn--primary" href="#sg-finder" data-sg-go-finder>Find my size in ' + esc(nice(styleName(p.t))) + '</a>' : '') +
      '<a class="sg-btn sg-btn--ghost" href="' + esc(p.u) + '">View the piece</a></div>';
    html += '</div></div>';
    pickedEl.innerHTML = html;
    pickedEl.hidden = false;
    initTracks(pickedEl);
  }

  function selectPiece(handle, opts) {
    opts = opts || {};
    var p = handle ? byHandle[handle] : null;
    state.piece = p || null;
    renderPicked();
    compute(false);
    save();
    try {
      var url = new URL(window.location.href);
      if (p) url.searchParams.set('piece', p.h); else url.searchParams.delete('piece');
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {}
    if (opts.scroll && p) {
      pickedEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      try { pickedEl.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  root.addEventListener('click', function (ev) {
    var pick = ev.target.closest && ev.target.closest('[data-sg-pick]');
    if (pick) {
      var h = pick.getAttribute('data-sg-pick');
      selectPiece(state.piece && state.piece.h === h ? null : h, { scroll: !(state.piece && state.piece.h === h) });
      return;
    }
    if (ev.target.closest && ev.target.closest('[data-sg-go-finder]')) {
      ev.preventDefault();
      var f = q('#sg-finder');
      f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      var first = q('#sg-bust');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 450);
      return;
    }
    if (ev.target.closest && ev.target.closest('[data-sg-choose]')) {
      ev.preventDefault();
      q('#sg-piece').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 450);
      return;
    }
    if (ev.target.closest && ev.target.closest('[data-sg-chat]')) {
      // Opens the site's chat panel when the widget is loaded; otherwise the link
      // falls through to the contact page.
      var btn = document.getElementById('sana-chat-btn');
      if (btn) { ev.preventDefault(); btn.click(); }
      return;
    }
    var sw = ev.target.closest && ev.target.closest('[data-sg-switch-in]');
    if (sw) { ev.preventDefault(); setUnit('in', true); }
  });

  // ── Finder ────────────────────────────────────────────────────────────────
  var form = q('[data-sg-form]');
  var resultEl = q('#sg-result');
  var FIELDS = ['bust', 'waist', 'hips', 'height'];
  function fieldInput(k) { return q('#sg-' + k); }

  function readField(k) {
    var el = fieldInput(k);
    var raw = String(el.value || '').trim().replace(',', '.');
    if (!raw) return { empty: true };
    var n = Number(raw);
    if (!isFinite(n) || n <= 0) return { error: 'Please enter a number, for example ' + (k === 'height' ? '165' : '88') + '.' };
    var cm = state.unit === 'in' ? n * IN : n;
    var lim = LIMITS[k];
    if (cm < lim[0] || cm > lim[1]) {
      if (state.unit === 'cm' && n * IN >= lim[0] && n * IN <= lim[1]) {
        return { error: 'That looks like inches. <button type="button" data-sg-switch-in>Switch to inches</button>' };
      }
      return { error: 'Please check this measurement' + (state.unit === 'cm' ? ' in centimetres.' : ' in inches.') };
    }
    return { cm: Math.round(cm * 2) / 2 };
  }

  function readAll(showErrors) {
    var vals = {};
    var bad = false;
    FIELDS.forEach(function (k) {
      var r = readField(k);
      var wrap = q('[data-sg-field="' + k + '"]');
      var err = q('#sg-' + k + '-err');
      if (r.error && showErrors) {
        wrap.classList.add('is-bad');
        err.innerHTML = r.error;
        err.hidden = false;
        fieldInput(k).setAttribute('aria-invalid', 'true');
      } else {
        wrap.classList.remove('is-bad');
        err.hidden = true;
        err.innerHTML = '';
        fieldInput(k).removeAttribute('aria-invalid');
      }
      if (r.error) bad = true;
      if (r.cm) vals[k] = r.cm;
    });
    return { vals: vals, bad: bad };
  }

  var CHAT_LINK = '<a class="sg-btn sg-btn--ghost" href="' + esc(root.getAttribute('data-contact')) + '" data-sg-chat>Chat with us</a>';

  function heightNote(p, h) {
    if (!p || !p.model || !p.model.heightCm || !(h > 0)) return '';
    var diff = h - p.model.heightCm;
    if (diff >= 8) return 'At ' + fmtVal(h) + ', the hem may sit a little higher than on our model (' + fmtVal(p.model.heightCm) + ').';
    if (diff <= -8) return 'At ' + fmtVal(h) + ', expect a little more length than on our model (' + fmtVal(p.model.heightCm) + ').';
    return '';
  }

  function renderResult(focus) {
    var vals = state.vals;
    var any = MEASURES.some(function (m) { return vals[m] > 0; });
    if (!any) {
      state.rec = null;
      resultEl.innerHTML = '<div class="sg-result-empty"><svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><rect x="6" y="22" width="52" height="20" rx="2"/><path d="M14 22v8M22 22v5M30 22v8M38 22v5M46 22v8M54 22v5"/></svg><p>' +
        (vals.height ? 'Add your bust, waist or hips and we\'ll recommend your size.' : 'Your recommended size will appear here, with the reason why.') + '</p></div>';
      return;
    }
    var p = state.piece;
    var html = '';
    if (p && p.group) {
      var g = p.group;
      var res = recommend(g.chart, vals);
      state.rec = { group: g, res: res };
      if (res.none) {
        html = '<p class="sg-why">The chart for ' + esc(nice(styleName(p.t))) + ' lists ' + esc(joinWords(g.chart.measures)) +
          '. Add your ' + esc(joinWords(res.missing)) + ' and we\'ll recommend your size.</p>';
      } else {
        var why = explain(res, g.chart);
        var sys = g.chart.systems.filter(function (s) { return res.entry.sys[s]; }).map(function (s) { return SYS_LABEL[s] + ' ' + res.entry.sys[s]; }).join(' · ');
        html += '<div class="sg-rec' + (why.warn ? ' is-warn' : '') + '"><div class="sg-rec-size" aria-hidden="true">' + esc(res.size) + '</div><div>' +
          '<p class="sg-eyebrow">' + (why.warn ? 'Our closest size' : 'Your size in ' + esc(nice(styleName(p.t)))) + '</p>' +
          '<h3>' + (why.warn ? 'Closest size: ' : 'We recommend ') + esc(res.size) + '</h3>' + (sys ? '<small>' + esc(sys) + '</small>' : '') + '</div></div>';
        html += '<p class="sg-why">' + why.html + '</p>';
        html += '<ul class="sg-break" aria-label="How each measurement fits">' + res.used.map(function (u) {
          var out = u.kind === 'above' || u.kind === 'below';
          return '<li' + (out ? ' class="is-out"' : '') + '><span>' + M_LABEL[u.m] + '</span><span>' + esc(fmtVal(u.v)) + '</span><b>' + esc(placeWord(u, g.chart)) + '</b></li>';
        }).join('') + '</ul>';
        if (res.ignored.length) html += '<p class="sg-info">This piece\'s chart lists ' + esc(joinWords(g.chart.measures)) + ' only, so we\'ve matched on ' + (g.chart.measures.length > 1 ? 'those' : 'that') + '.</p>';
        if (res.missing.length) html += '<p class="sg-info">Add your ' + esc(joinWords(res.missing)) + ' for a closer match.</p>';
        var hn = heightNote(p, vals.height);
        if (hn) html += '<p class="sg-info">' + esc(hn) + '</p>';
        if (p.model) html += '<p class="sg-info">' + esc(p.model.text) + '.</p>';
        var variant = p.v[res.size];
        if (variant && variant[1] === false) html += '<p class="sg-info is-warn">' + esc(res.size) + ' is currently sold out in ' + esc(nice(p.t)) + '.</p>';
        html += '<div class="sg-result-actions">';
        if (variant && variant[1] !== false && !why.warn) {
          html += '<a class="sg-btn sg-btn--primary" href="' + esc(p.u) + '?variant=' + esc(variant[0]) + '">Shop ' + esc(nice(styleName(p.t))) + ' in ' + esc(res.size) + '</a>';
        } else if (!why.warn) {
          html += '<a class="sg-btn sg-btn--primary" href="' + esc(p.u) + '">View ' + esc(nice(styleName(p.t))) + '</a>';
        }
        if (why.warn) html += CHAT_LINK.replace('sg-btn--ghost', 'sg-btn--primary');
        html += '<a class="sg-btn sg-btn--ghost" href="#' + g.id + '" data-sg-see-chart>See the full chart</a></div>';
      }
    } else if (p && !p.group) {
      state.rec = null;
      html = '<p class="sg-why">We don\'t have a size chart for ' + esc(nice(p.t)) + ' on our website yet, so we can\'t recommend a size from your measurements. Chat with us and we\'ll help you choose.</p><div class="sg-result-actions">' + CHAT_LINK.replace('sg-btn--ghost', 'sg-btn--primary') + '</div>';
    } else {
      state.rec = null;
      html += '<p class="sg-eyebrow">Your size across our collection</p>' +
        '<p class="sg-why">Each style has its own size chart. Here is your size in each one, sizing up wherever you\'re between sizes.</p><ul class="sg-over">';
      var warnAny = false;
      groups.forEach(function (g) {
        var r = recommend(g.chart, vals);
        if (r.none) {
          html += '<li><span>' + esc(g.title) + '<small>Add your ' + esc(joinWords(r.missing)) + ' for this chart</small></span><b class="is-warn">–</b></li>';
          return;
        }
        var w = r.above.length || r.allBelow;
        if (w) warnAny = true;
        var note = w ? (r.above.length ? 'Above our largest size; closest shown' : 'Below our smallest size; closest shown')
          : r.between ? 'Between ' + r.lower + ' and ' + r.size + ', sized up' : '';
        html += '<li><span>' + esc(g.title) + (note ? '<small>' + esc(note) + '</small>' : '') + '</span><b' + (w ? ' class="is-warn"' : '') + '>' + esc(r.size) + '</b></li>';
      });
      html += '</ul><p class="sg-info" style="margin-top:14px">Choose your piece for a personal recommendation with the reason why.</p>';
      if (warnAny) html += '<p class="sg-info is-warn">Some of your measurements sit outside a chart. We\'d love to help you choose before you order.</p>';
      html += '<div class="sg-result-actions"><button type="button" class="sg-btn sg-btn--primary" data-sg-choose>Choose your piece</button>' + (warnAny ? CHAT_LINK : '') + '</div>';
    }
    resultEl.innerHTML = html;
    if (focus && window.matchMedia && !window.matchMedia('(min-width: 760px)').matches) {
      resultEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      try { resultEl.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function compute(fromSubmit) {
    var r = readAll(!!fromSubmit || compute.touched);
    state.vals = r.vals;
    renderResult(fromSubmit && !r.bad);
    refreshCharts();
  }
  compute.touched = false;

  // Charts reflect the unit and highlight the recommended size.
  function refreshCharts() {
    renderAllCharts();
    if (state.piece && state.piece.group) {
      var holder = q('#sg-picked .sg-chart');
      if (holder) {
        var tmp = document.createElement('div');
        tmp.innerHTML = renderChart(state.piece.group, { head: false });
        holder.parentNode.replaceChild(tmp.firstChild, holder);
        initTracks(pickedEl);
      }
    }
  }

  root.addEventListener('click', function (ev) {
    var see = ev.target.closest && ev.target.closest('[data-sg-see-chart]');
    if (!see) return;
    ev.preventDefault();
    var el = document.getElementById(see.getAttribute('href').slice(1));
    if (el) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  var inputTimer = null;
  if (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      compute.touched = true;
      compute(true);
      save();
    });
    FIELDS.forEach(function (k) {
      var el = fieldInput(k);
      el.addEventListener('input', function () {
        clearTimeout(inputTimer);
        inputTimer = setTimeout(function () { compute(false); save(); }, 250);
      });
      el.addEventListener('blur', function () {
        if (el.value) { compute.touched = true; compute(false); save(); }
      });
    });
    q('[data-sg-forget]').addEventListener('click', function () {
      FIELDS.forEach(function (k) { fieldInput(k).value = ''; });
      compute.touched = false;
      try { window.localStorage.removeItem(STORE_KEY); } catch (e) {}
      compute(false);
    });
  }

  // ── Unit toggle (two synced controls) ─────────────────────────────────────
  function syncUnitControls() {
    qa('input[name="sg-unit"], input[name="sg-unit-2"]').forEach(function (r) {
      r.checked = r.value === state.unit;
      r.parentNode.classList.toggle('is-on', r.checked);
    });
    qa('[data-sg-unit-label]').forEach(function (el) { el.textContent = state.unit; });
    var ph = state.unit === 'in' ? { bust: '35', waist: '27', hips: '38', height: '65' } : { bust: '88', waist: '68', hips: '96', height: '165' };
    FIELDS.forEach(function (k) { fieldInput(k).placeholder = ph[k]; });
  }
  function setUnit(u, convert) {
    if (u === state.unit) return;
    if (convert) {
      FIELDS.forEach(function (k) {
        var el = fieldInput(k);
        var n = Number(String(el.value || '').trim().replace(',', '.'));
        if (!el.value || !isFinite(n) || n <= 0) return;
        if (state.unit === 'cm' && u === 'in') {
          // A value already typed in inches (the "looks like inches" case) stays as typed.
          var lim = LIMITS[k];
          el.value = (n >= lim[0] && n <= lim[1]) ? num(n / IN) : num(n);
        } else {
          el.value = num(Math.round(n * IN * 2) / 2);
        }
      });
    }
    state.unit = u;
    syncUnitControls();
    compute(false);
    save();
  }
  qa('input[name="sg-unit"], input[name="sg-unit-2"]').forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) setUnit(r.value, true); });
  });

  // ── Persistence: this device only ─────────────────────────────────────────
  function save() {
    try {
      var data = { u: state.unit, p: state.piece ? state.piece.h : null, m: {} };
      FIELDS.forEach(function (k) { if (state.vals[k]) data.m[k] = state.vals[k]; });
      window.localStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) {}
  }
  function load() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  // ── Start ─────────────────────────────────────────────────────────────────
  var saved = load();
  if (saved && (saved.u === 'in' || saved.u === 'cm')) state.unit = saved.u;
  syncUnitControls();
  if (saved && saved.m) {
    FIELDS.forEach(function (k) {
      var cm = Number(saved.m[k]);
      if (cm > 0) fieldInput(k).value = state.unit === 'in' ? num(cm / IN) : num(cm);
    });
  }
  var startPiece = null;
  try { startPiece = new URL(window.location.href).searchParams.get('piece'); } catch (e) {}
  if (!startPiece && saved && saved.p) startPiece = saved.p;
  state.piece = startPiece && byHandle[startPiece] ? byHandle[startPiece] : null;
  renderPicked();
  compute(false);
  if (startPiece && state.piece && /[?&]piece=/.test(window.location.search) && !window.location.hash) {
    setTimeout(function () { q('#sg-finder').scrollIntoView({ block: 'start' }); }, 0);
  }
})();
